import { Box, Typography } from '@mui/material';
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const ConsultatinoHistoryChart = ({ arrdata }) => {
  const alldataZero = arrdata.every(item => item.value === 0);

  // If all are zero, create a grey placeholder pie data
  const placeholderData = [{ name: 'Placeholder', value: 1, color: '#1648ce' }];

  const dataToShow = alldataZero ? placeholderData : arrdata;
  return (
    <div className="bg-white p-4 rounded-xl  shadow-blue_dropshadow w-full">
    <p className="headingText text-coalBlack text-left ">
      Consultation History
    </p>
    <div className="grid grid-cols-1 gap-2 my-2">
      <div className="min-h-[206px] md:min-h-[275px] ">
      <PieChart width={180} height={180} className="ml-auto mr-auto text-center">
        <Pie
          data={dataToShow}
          cx="50%"
          cy="50%"
          innerRadius={40}
          outerRadius={70}
          paddingAngle={2}
          dataKey="value"
        >
          {dataToShow.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      <Box className="flex flex-col space-y-1 mt-1 gap-1 mr-auto ml-auto w-[150px]">
        {arrdata.map((item, idx) => (
          <Box key={idx} className="flex items-center mb-1">
            <Box
              className="w-[20px] h-[20px] rounded-[3px] mr-[10px]"
              style={{ backgroundColor: item.color }}
            />
            <Typography variant="h4" className="!text-[16px] font-normal !font-normal text-[#aaa7b1] !m-0">
              {item.name} ({item.value})
            </Typography>
          </Box>
        ))}
      </Box>
      </div>
    </div>
  </div>
  );
};

export default ConsultatinoHistoryChart;